import InputDefault from './input';

export { InputDefault };
export default InputDefault;
